import { useDispatch, useSelector } from 'react-redux';
import {
  isNotificationModalOpenSelector,
  missingFieldsSelector,
  NotificationOptionTypes,
  notificationTextSelector,
  notificationTypeSelector,
  setMissingFields,
  setNotificationModalOpen,
  setNotificationText,
  setNotificationType,
} from '../../../store/slices/adminSlice';
import { Modal } from '@mantine/core';
import WFIDButton from '../../../components/WFIDButton/WFIDButton';

const ModalNotificationComponent = () => {
  const isNotificationModalOpen = useSelector(isNotificationModalOpenSelector);
  const missingFields = useSelector(missingFieldsSelector);
  const notificationType = useSelector(notificationTypeSelector);

  const notificationText = useSelector(notificationTextSelector);

  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setNotificationModalOpen(false));
    dispatch(setMissingFields([]));
    dispatch(setNotificationText(''));
    dispatch(setNotificationType(null));
  };

  return (
    <div>
      <Modal
        bg='red'
        radius={8}
        size='lg'
        opened={isNotificationModalOpen}
        centered
        onClose={handleClose}
        withCloseButton={false}
        overlayProps={{
          backgroundOpacity: 0,
          blur: 0,
        }}
      >
        <div className='ModalNotification__header'>
          {notificationType === NotificationOptionTypes.MissingHeaders && (
            <p className='message-type'>Error: File is missing the following required fields. Please check you are using the latest template.</p>
          )}
          {notificationType === NotificationOptionTypes.Success && (
            <p className='message-type'>Species successfully updated.</p>
          )}
          {notificationType === NotificationOptionTypes.MissingHeaders && (
            <p className='required-fields'>
              Required fields: <span>{missingFields.join(', ')}</span>
            </p>
          )}
          {(notificationType === NotificationOptionTypes.Success ||
            notificationType === NotificationOptionTypes.Error) && (
            <p className='default-message'>{notificationText}</p>
          )}
        </div>
        <div className='modal-btn-container'>
          <WFIDButton content='close' onClick={handleClose} />
        </div>
      </Modal>
    </div>
  );
};

export default ModalNotificationComponent;
